import React, { useMemo } from 'react'
import ChartWrapper, { ChartProps } from '../Common/ChartWrapper'
import GenericBinarySrcGraph from '../../GeneralBinarySrcGraph/GenericBinarySrcGraph'
import commandPlugin from '../../GeneralBinarySrcGraph/plugins/command'
import { baseMetricsWithWarnAreasPluginForSG1AssetWithInverter } from '../../GeneralBinarySrcGraph/plugins/baseMetricsForSG1'
import backwardForwardTimeSummaryPlugin from '../../GeneralBinarySrcGraph/plugins/backwardForwardTimeSummary/backwardForwardTimeSummary'
import { ChartPlugin } from '../../GeneralBinarySrcGraph/_types'
import { Workshift } from '@mv-submodules/inplant-plantanalysis-fe-iblu/types/workshift'

// asset ids are a list that comes from a requesto of the customer
const assetPlugins: Record<string, ChartPlugin[]> = {
  IBSGNMRQMBLXVSGA: [backwardForwardTimeSummaryPlugin],
  IBSGNMRQMBLXY7TU: [backwardForwardTimeSummaryPlugin],
  IBSGNMRQMBLXWNHR: [backwardForwardTimeSummaryPlugin],
}

function _Content(props: ChartProps & { plant: string; workShift: Workshift }) {
  const { component, plant, workShift } = props

  const plugins = useMemo(() => {
    const _plugins = [commandPlugin]
    if (component.nodeType.includes('INVERTER')) {
      _plugins.push(baseMetricsWithWarnAreasPluginForSG1AssetWithInverter)
    }
    if (assetPlugins[component.id]) {
      _plugins.push(...assetPlugins[component.id])
    }
    return _plugins
  }, [])

  return (
    <GenericBinarySrcGraph
      id={component.id}
      plant={plant}
      workShift={workShift}
      plugins={plugins}
      measures={[
        {
          slug: 'direction',
          id: 'BS_DIR',
          representation: 'time-bar',
        },
      ]}
    />
  )
}

function BeltChart(props: ChartProps) {
  const { currentGraph, component, toggleCollapse } = props
  return (
    <ChartWrapper currentGraph={currentGraph} component={component} toggleCollapse={toggleCollapse}>
      {({ plant, workShift }) => (
        <_Content {...props} plant={plant} workShift={workShift} />
      )}
    </ChartWrapper>
  )
}

export default BeltChart
